import { alpha } from '@mui/material';
/**
 *
 * MuiSwitch
 *
 * Demos:
 *
 * - [Switch](https://ui-packages.isbuildingluma.com/ui-core/react-switch/)
 *
 * API:
 *
 * - [Switch API](https://ui-packages.isbuildingluma.com/ui-core/api/switch/)
 * - inherits [MuiSwitch API](https://mui.com/material-ui/api/switch/)
 */
const MuiSwitch = {
  styleOverrides: {
    root: ({
      ownerState,
      theme
    }) => {
      const colorKey = !ownerState.color || ownerState.color === 'default' ? 'primary' : ownerState.color;
      // @ts-ignore
      let color = theme.palette[colorKey].main;
      let colorUnchecked = theme.palette.grey[600];
      if (ownerState.disabled) {
        color = alpha(color, 0.5);
        colorUnchecked = alpha(colorUnchecked, 0.5);
      }
      return {
        width: 52,
        height: 32,
        padding: 0,
        marginRight: theme.spacing(1.5),
        borderRadius: '100px',
        '& .MuiSwitch-switchBase': {
          padding: 0,
          transform: 'translate(4px, 4px)',
          transition: '.3s',
          '& + .MuiSwitch-track': {
            opacity: 1,
            border: `1px solid ${theme.palette.grey[300]}`,
            backgroundColor: theme.palette.common.white,
            borderRadius: '100px'
          },
          '&.Mui-checked': {
            transform: 'translate(24px, 4px)',
            transition: '.3s',
            '& .MuiSwitch-thumb:before': {
              backgroundColor: theme.palette.common.white,
              borderRadius: '100%',
              backgroundPosition: '5px 4px'
            },
            '& + .MuiSwitch-track': {
              opacity: 1,
              backgroundColor: color,
              border: 'none'
            }
          }
        },
        '& .MuiSwitch-thumb': {
          backgroundColor: colorUnchecked,
          boxShadow: 'none',
          width: '24px',
          height: '24px',
          '&:before': {
            content: "''",
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '6px 6px'
          }
        }
      };
    }
  }
};
export default MuiSwitch;